import { useRecoilState, useRecoilValue } from 'recoil';
import cn from "classnames";

import { CSS_COMPONENT_PREFIX } from 'config';
import { favouriteTickets, highlightedFavouriteTicket, selectedFavouriteTicket } from 'state';
import t from "lib/i18n";

import FavouriteTicket from "components/favourites/FavouriteTicket";
import SrOnly from 'components/helpers/SrOnly';
import { useEffect } from 'react';

const TicketSelectionList = () => {
  const tickets = useRecoilValue(favouriteTickets);
  const selectedTicket = useRecoilValue(selectedFavouriteTicket);
  const [highlightedTicket, setHighlightedTicket] = useRecoilState(highlightedFavouriteTicket);

  useEffect(() => {
    if (tickets?.length && !highlightedTicket) {
      setHighlightedTicket(selectedTicket || tickets[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const listItemBaseClass = CSS_COMPONENT_PREFIX + 'favourite-ticket-list__item';
  
  return (
    <ul className="otrl-jp__favourite-ticket-list">
      {tickets.map((ticket, index) =>
        <li
          key={ticket.id}
          className={cn(listItemBaseClass, {
            [`${listItemBaseClass}--highlighted`]: ticket === highlightedTicket
          })}
        >
          <SrOnly>{tickets && t('favourites.ticketSelection.list.aria', { index: index + 1, total: tickets.length})}</SrOnly>
          <FavouriteTicket
            ticket={ticket}
            onAction={() => setHighlightedTicket(ticket)}
          />
        </li>
      )}
    </ul>
  );
};

export default TicketSelectionList;
